import { Link } from 'react-router';
import type { LatestChanges } from '../settingsApi.js';
import { SETTING_GROUP, type SettingKey, describeChanges, formatMyt } from '../settingsFormat.js';

/**
 * 356 (FR-020): "Last changed 5 Oct, 06:35 by Aina: Auto-cancel Off → On · History", or
 * "Not changed since history began". History opens the History tab filtered to the card's group.
 */
export function LastChanged({ setting, latest }: { setting: SettingKey; latest?: LatestChanges }) {
  const entry = latest?.[setting];
  const historyLink = (
    <Link
      to={`?tab=history&group=${SETTING_GROUP[setting]}`}
      className="text-primary hover:underline"
    >
      History
    </Link>
  );
  if (!entry) {
    return (
      <span data-testid={`last-changed-${setting}`} className="text-xs text-steel">
        Not changed since history began · {historyLink}
      </span>
    );
  }
  const { last } = entry;
  const who = last.actor.kind === 'system' ? 'the system' : (last.actor.name ?? 'a staff member');
  return (
    <span data-testid={`last-changed-${setting}`} className="text-xs text-steel">
      Last changed <b className="font-semibold text-charcoal">{formatMyt(last.at)}</b> by{' '}
      <b className="font-semibold text-charcoal">{who}</b>: {describeChanges(setting, last.changes)}{' '}
      · {historyLink}
    </span>
  );
}
